<header class="header-container" *ngIf="this.getNome() === 'null' ? false : true">
  <div class="logo-container">
    <img src="assets/Logomarca.svg" />
  </div>
  <div class="user">
    <div class="user-image">
      <img src="assets/icon-person.png" />
    </div>
    <div class="user-info">
      <span class="user-name">{{ getNome() }}</span>
    </div>
    <span class="logout" (click)="logout()">
      <img src="assets/logout-v2.svg" />
      <span>Sair</span>
    </span>
  </div>
</header>
